/* eslint-disable @typescript-eslint/no-explicit-any */
import ReactDOM from 'react-dom';
import { Component, HTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';

const modalRoot = document.getElementById('modal-root') as HTMLElement;

export default class ModalV3 extends Component<
  {
    open?: boolean;
    onClickBackdrop?: () => void;
    children: ReactNode;
  } & HTMLAttributes<HTMLDivElement>
> {
  el: any;

  constructor(props: any) {
    super(props);
    // @ts-ignore
    this.el = document.createElement('div');
  }

  componentDidMount() {
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    modalRoot?.appendChild(this.el);
  }

  componentWillUnmount() {
    modalRoot?.removeChild(this.el);
  }

  render() {
    const { className, onClickBackdrop, open, children, style } = this.props;
    if (!open) {
      return ReactDOM.createPortal(null, this.el);
    }

    return ReactDOM.createPortal(
      <div
        className='modal modal-open'
        style={style}
        onClick={() => {
          if (onClickBackdrop) {
            onClickBackdrop();
          }
        }}
      >
        <div
          className={classNames('modal-box p-0 rounded-none', className)}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {children}
        </div>
      </div>,
      this.el
    );
  }
}
